.distanceRefinementContainer {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-4);
  margin-top: var(--cxy-spacing-2);
}

.distanceRefinementItems {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-4);
}

.resetButton {
  align-self: center;
}
